export default {
    finance: {
        loanPrograms: {
            title: "Programas de emprestimo",
            create: "Criar programa de emprestimo",
            edit: "Editar programa de emprestimo",
            details: "Detalhes do programa",
            programTitle: "Titulo do programa",
            programLogo: "Logotipo do programa",
            applicationForm: "Formulario de solicitacao",
            viewApplications: "Ver solicitacoes",
            cooperative: "Cooperativa",
            bank: "Banco",
            status: "Status",
            allStatuses: "Todos os status",
            active: "Ativo",
            inactive: "Inativo",
            approvalFlowSetting: "Configuracao do fluxo de aprovacao",
            concludeBeforeBank: "Concluir uma solicitacao de emprestimo antes de enviar ao banco.",
            allowBankRequestInfo: "Permitir que o banco solicite mais informacoes ao solicitante.",
            currency: "Moeda",
            loanAmountMin: "Valor do emprestimo - Minimo",
            loanAmountMax: "Valor do emprestimo - Maximo",
            term: "Prazo",
            yield: "Rendimento",
            typeOfFinancing: "Tipo de financiamento",
            gracePeriod: "Periodo de carencia",
            country: "Pais",
            regions: "Regioes",
            crops: "Culturas",
            dataFields: "Campos de dados",
            dataFieldsConfigured: "Campos de dados configurados para este programa de emprestimo",
            signature: "Assinatura",
            viewSignatureFile: "Ver assinatura / arquivo",
            description: "Descricao",
            conditionsRequirements: "Condicoes e requisitos",
            digitalSignature: "Assinatura digital",
            fileUpload: "Upload de arquivo",
            failedLoadLoanProgramDetails: "Falha ao carregar os detalhes do programa de emprestimo",
            failedLoadLoanProgram: "Falha ao carregar o programa de emprestimo",
            failedLoadApplicationForm: "Falha ao carregar o formulario de solicitacao",
            loanProgramUpdatedSuccess: "Programa de emprestimo atualizado com sucesso",
            loanProgramCreatedSuccess: "Programa de emprestimo criado com sucesso",
            applicationFormUpdatedSuccess: "Formulario de solicitacao atualizado com sucesso",
            failedUpdateLoanProgram: "Falha ao atualizar o programa de emprestimo",
            failedCreateLoanProgram: "Falha ao criar o programa de emprestimo",
            failedUpdateApplicationForm: "Falha ao atualizar o formulario de solicitacao",
            fillRequiredFields: "Preencha todos os campos obrigatorios",
            fileUploadRequiredFor: "Upload de arquivo e obrigatorio para",
            selectAtLeastOneOptionFor: "Selecione pelo menos uma opcao para",
            fieldRequired: "Este campo e obrigatorio",
            chooseValidOptionFor: "Escolha uma opcao valida para",
            enterValidAmountFor: "Informe um valor valido para",
            selectValidUnitFor: "Selecione uma unidade valida para",
            step1ProgramDetails: "Etapa 1: Detalhes do programa",
            step2ApplicationForm: "Etapa 2: Formulario de solicitacao",
            months: "meses",
            years: "anos",
            days: "dias",
            weeks: "semanas",
            previewForm: "VISUALIZAR FORMULARIO",
            backUpper: "VOLTAR",
            basicInformation: "Informacoes basicas",
            basicInformationHint: "Insira as informacoes basicas para o programa de emprestimo.",
            enterProgramTitle: "Digite o titulo do programa",
            attachProgramLogo: "Anexar logotipo do programa",
            selectProgramLogoImage: "Selecione a imagem do logotipo do programa",
            selectFileUploadProgramLogo: "Selecione o arquivo para enviar o logotipo do programa",
            orDragDrop: "ou arraste e solte aqui",
            removeFile: "Remover arquivo",
            loanProgramSettings: "Configuracoes do programa de emprestimo",
            loanProgramSettingsHint: "Insira as configuracoes do programa de emprestimo.",
            selectBank: "Selecione o banco",
            applicationApproval: "Aprovacao da solicitacao",
            applicationProcess: "Processo da solicitacao",
            loanDetails: "Detalhes do emprestimo",
            loanDetailsHint: "Insira os detalhes do emprestimo para o programa.",
            selectCurrency: "Selecione a moeda",
            enterMinLoanAmount: "Digite o valor minimo do emprestimo",
            enterMaxLoanAmount: "Digite o valor maximo do emprestimo",
            enterHere: "Digite aqui",
            interestRate: "Taxa de juros",
            yieldPerYear: "Rendimento - por ano",
            enterYieldPerYear: "Digite o rendimento por ano",
            selectTypeOfFinancing: "Selecione o tipo de financiamento",
            gracePeriodMax: "Periodo de carencia - Maximo",
            selectCrops: "Selecione culturas",
            selectCountry: "Selecione o pais",
            selectRegions: "Selecione regioes",
            addNewDataField: "ADICIONAR NOVO CAMPO DE DADOS",
            enterProgramDescription: "Digite a descricao do programa",
            programApplicationForm: "Formulario de solicitacao do programa",
            defineAndManageCustomDataFields: "Defina e gerencie campos de dados personalizados para a solicitacao de emprestimo.",
            addDataField: "ADICIONAR CAMPO DE DADOS",
            dataField: "Campo de dados",
            type: "Tipo",
            subdata: "Subdado",
            mandatory: "Obrigatorio",
            group: "Grupo",
            yes: "Sim",
            no: "Nao",
            noDataFieldsYet: "Nenhum campo de dados adicionado ainda. Clique em ADICIONAR CAMPO DE DADOS para criar um.",
            textField: "Campo de texto",
            textArea: "Area de texto",
            textFieldNumeric: "Campo numerico",
            radioButton: "Botao de opcao",
            checkBoxes: "Caixas de selecao",
            dropdown: "Lista suspensa",
            measurementUnit: "Unidade de medida",
            attachFile: "Anexar arquivo",
            digitalSignatureLabel: "Assinatura digital",
            dataList: "Lista de dados",
            date: "Data",
            selectDataType: "Selecione o tipo de dado",
            fieldTitle: "Titulo do campo",
            groupTitle: "Titulo do grupo",
            enterGroupTitle: "Digite o titulo do grupo",
            allowMultipleInputs: "Permitir multiplas entradas",
            allowedFileTypes: "Tipos de arquivo permitidos",
            imageJpegGifPng: "Imagem (JPEG, GIF, PNG)",
            videoMp4: "Video (MP4)",
            docx: "DOCX",
            options: "Opcoes",
            typeHere: "Digite aqui",
            unitType: "Tipo de unidade",
            selectUnitType: "Selecione o tipo de unidade",
            selectType: "Selecione o tipo",
            allowUserToChangeUnitType: "Permitir que o usuario altere o tipo de unidade",
            help: "Ajuda",
            writeHelpTextUsers: "Escreva um texto de ajuda para os usuarios.",
            helpText: "Texto de ajuda",
            addHelpTextForThisDataField: "Adicione texto de ajuda para este campo de dados",
            addFieldToGroup: "Adicionar campo ao grupo",
            cancelUpper: "CANCELAR",
            submitUpper: "ENVIAR",
            groupTitleRequired: "O titulo do grupo e obrigatorio",
            atLeastOneFieldRequiredInGroup: "Pelo menos um campo e obrigatorio em um grupo",
            fieldTitleRequiredForAllGroupFields: "O titulo do campo e obrigatorio para todos os campos do grupo",
            atLeastOneOptionRequiredFor: "Pelo menos uma opcao e obrigatoria para",
            atLeastOneFileTypeMustBeSelected: "Pelo menos um tipo de arquivo deve ser selecionado",
            fieldTitleRequired: "O titulo do campo e obrigatorio",
            atLeastOneOptionRequired: "Pelo menos uma opcao e obrigatoria",
        },
        loanApplications: {
            activityDescription: "Descricao da atividade",
            activityLog: "Registo de atividade",
            addAnyInternalNotesOrReviewCommentsAboutThisLoanApplication: "Adicione notas internas ou comentarios de revisao sobre este pedido de credito.",
            additionalInformationRequested: "Informacao adicional solicitada",
            additionalLoanRelatedQuestionsAndSupportingDocuments: "Questoes adicionais sobre o credito e documentos de suporte.",
            additionalQuestions: "Questoes adicionais",
            address: "Morada",
            amount: "Montante",
            applicantDetails: "Dados do requerente",
            applicationHasBeenSentToTheBankForApproval: "O pedido foi enviado ao banco para aprovacao.",
            applicationId: "ID do pedido",
            applicationIdAndSubmissionDate: "ID do pedido e data de submissao",
            apply: "Aplicar",
            approvalProcess: "Processo de aprovacao",
            approvalProcessHasBeenStartedYouCanNowFillFinalizeContractAndLoanDetails: "O processo de aprovacao foi iniciado. Agora pode preencher Finalizar contrato e Detalhes do credito.",
            approve: "Aprovar",
            approved: "Aprovado",
            areYouSureYouWantToApproveTheLoanApplication: "Tem a certeza de que pretende aprovar o pedido de credito?",
            areYouSureYouWantToRejectTheLoanApplication: "Tem a certeza de que pretende rejeitar o pedido de credito?",
            areYouSureYouWantToSendTheApplicationToTheBankForApprovalProcess: "Tem a certeza de que pretende enviar o pedido ao banco para o processo de aprovacao?",
            areYouSureYouWantToStartTheApprovalProcess: "Tem a certeza de que pretende iniciar o processo de aprovacao?",
            area: "Area",
            areaHa: "Area (ha)",
            attachContractOptional: "Anexar contrato (opcional)",
            attachment: "Anexo",
            back: "Voltar",
            cancel: "Cancelar",
            circular: "Circular",
            close: "Fechar",
            closeUpper: "FECHAR",
            confirm: "Confirmar",
            confirmation: "Confirmacao",
            contract: "Contrato",
            couldNotLoadLoanApplication: "Nao foi possivel carregar o pedido de credito.",
            couldNotSendRequest: "Nao foi possivel enviar o pedido.",
            couldNotUpdateApplication: "Nao foi possivel atualizar o pedido.",
            country: "Pais",
            customization: "Personalizacao",
            date: "Data",
            dateAndTime: "Data e hora",
            describeHere: "Descreva aqui",
            description: "Descricao",
            digitallySigned: "Assinado digitalmente",
            disclaimerTitle: "Aviso legal",
            disbursedAmount: "Montante desembolsado",
            disbursementScheduleFromBankToFarmer: "Calendario de desembolsos do banco para o agricultor.",
            doYouWantUsToCollectTheContractSignature: "Pretende que recolhamos a assinatura do contrato?",
            doYouWantUsToCollectTheContractSignatureIfYesAttachTheContractOptionalAndWeWillSendItToTheFarmerToSignInTheAppIfNoTheContractIsAlreadySignedOrWillBeSignedOfflineAfterYouAttachAndSaveTheContractWillBeSentToTheFarmerToSignYouLlReceiveANotificationOnceItSSigned: "Pretende que recolhamos a assinatura do contrato? Se sim, anexe o contrato (opcional) e envia-lo-emos ao agricultor para assinar na app. Se nao, o contrato ja esta assinado ou sera assinado offline. Apos anexar e guardar, o contrato sera enviado ao agricultor para assinatura; recebera uma notificacao quando estiver assinado.",
            download: "Baixar",
            dueDate: "Data de vencimento",
            email: "E-mail",
            enterHere: "Introduza aqui",
            error: "Erro",
            farm: "Exploracao",
            farmDetails: "Detalhes da exploracao",
            farmReports: "Relatorios da exploracao",
            farmer: "Agricultor",
            farmerResponse: "Resposta do agricultor",
            farmerUpdates: "Atualizacoes do agricultor",
            farmReportsSoilDisclaimer: "As informacoes desta secao sao apenas para referencia geral. Nao substituem analise profissional de solo em laboratorio. Use apenas se outras opcoes de analise nao estiverem disponiveis. Consulte sempre especialistas agricolas antes de decidir.",
            farmReportsYieldBullet1: "E impossivel prever com precisao o tempo para toda a epoca; por vezes os agricultores perdem toda a colheita por granizo ou inundacao (sobretudo com as irregularidades do aquecimento global).",
            farmReportsYieldBullet2: "As produtividades dependem muito das praticas de gestao. Por exemplo, se os pesticidas nao forem aplicados a tempo ou a rega for insuficiente, os resultados podem diferir muito das previsoes; isto tambem esta fora do nosso controlo.",
            farmReportsYieldBullet3: "Existem muitos outros fatores semelhantes que podem causar erros significativos nas previsoes de produtividade por IA.",
            farmReportsYieldBullet4: "Se o agricultor fornecer produtividades historicas (modo AVANCADO), as previsoes tendem a ser mais precisas do que no modo predefinido (nao AVANCADO).",
            farmReportsYieldUncertaintyIntro: "Nas nossas previsoes de produtividade a incerteza pode ser de 100% porque muitos fatores estao fora do nosso controlo, incluindo:",
            forecastedYields: "Produtividades previstas",
            graph: "Grafico",
            yieldsKgAxis: "Produtividades (kg)",
            yieldForecasts: "Previsoes de produtividade",
            farmerUploadedAttachmentS: "O agricultor carregou anexo(s).",
            finalizeContract: "Finalizar contrato",
            financeManagement: "Gestao financeira",
            firstName: "Nome",
            generatePaymentSchedule: "GERAR CALENDARIO DE PAGAMENTOS",
            geolocation: "Geolocalizacao",
            gracePeriod: "Periodo de carencia",
            gracePeriodType: "Tipo de periodo de carencia",
            historyOfActionsTakenOnThisLoanApplication: "Historico de acoes neste pedido de credito.",
            ifYouWantUsToCollectTheApplicantSSignatureChooseYesAndAttachTheContractAfterYouSaveItWillBeSentToTheFarmerToSignInTheAppYouLlReceiveANotificationOnceSignedContractUploadIsOptionalEGIfTheContractIsAlreadySignedOrWillBeSignedOffline: "Se pretender que recolhamos a assinatura do requerente, escolha Sim e anexe o contrato. Apos guardar, sera enviado ao agricultor para assinar na app; recebera uma notificacao quando estiver assinado. O carregamento do contrato e opcional (p.ex. ja assinado ou a assinar offline).",
            information: "Informacao",
            informationRequestedFromBank: "Informacao solicitada ao banco",
            installment: "Prestacao",
            installmentDetails: "Detalhes da prestacao",
            interestRate: "Taxa de juro",
            ipAddress: "Endereco IP",
            keySoilNutrientLevelsForTheFarm: "Niveis-chave de nutrientes do solo na exploracao.",
            landSuitabilityReport: "Relatorio de aptidao da terra",
            lastName: "Apelido",
            loadingData: "A carregar dados...",
            loanAmount: "Montante do credito",
            loanApplicationDetails: "Detalhes do pedido de credito",
            loanApplicationHasBeenApproved: "O pedido de credito foi aprovado.",
            loanApplicationHasBeenRejected: "O pedido de credito foi rejeitado.",
            loanApplications: "Pedidos de credito",
            loanDetails: "Detalhes do credito",
            loanDetailsSummary: "Resumo dos detalhes do credito.",
            loanDisbursementBankFarmer: "Desembolso do credito (Banco -> Agricultor)",
            loanDisbursementPlan: "Plano de desembolso do credito",
            loanProgram: "Programa de credito",
            loanPrograms: "Programas de credito",
            loanRepaymentFarmerBank: "Reembolso do credito (Agricultor -> Banco)",
            loanRepaymentPlan: "Plano de reembolso do credito",
            missingApplicationId: "Falta o ID do pedido.",
            moderate: "Moderado",
            notApplicable: "N/A",
            nitrogenContent: "Teor de azoto",
            noAdditionalQuestions: "Sem questoes adicionais.",
            noContractIsAlreadySignedOrWillBeSignedOffline: "Nao — o contrato ja esta assinado ou sera assinado offline",
            noMapCoordinatesForThisFarm: "Sem coordenadas de mapa para esta exploracao.",
            notes: "Notas",
            numberOfDisbursements: "Numero de desembolsos",
            numberOfInstallments: "Numero de prestacoes",
            of: "de",
            openFile: "Abrir ficheiro",
            orDragAndDropHere: "ou arraste e largue aqui",
            overallLandSuitabilityScoreAndCategory: "Pontuacao global de aptidao da terra e categoria.",
            overallScoreForLandSuitability: "Pontuacao global de aptidao da terra",
            paid: "Pago",
            paymentDetails: "Detalhes do pagamento",
            payments: "Pagamentos",
            pending: "Pendente",
            phoneNumber: "Telefone",
            phosphorusContent: "Teor de fosforo",
            pleaseEnterAValidInterestRateToGenerateRepaymentPlan: "Introduza uma taxa de juro valida para gerar o plano de reembolso.",
            pleaseEnterAValidLoanAmountToGenerateDisbursementPlan: "Introduza um montante de credito valido para gerar o plano de desembolso.",
            pleaseEnterAValidLoanAmountToGenerateRepaymentPlan: "Introduza um montante de credito valido para gerar o plano de reembolso.",
            pleaseEnterNumberOfInstallmentsToGenerateRepaymentPlan: "Introduza o numero de prestacoes para gerar o plano de reembolso.",
            pleaseEnterYourCommentsOrInstructions: "Introduza os seus comentarios ou instrucoes.",
            pleaseProvideSpecificCommentsOrInstructionsInTheTextBoxBelowOnceSubmittedTheFarmerWillBeNotifiedYouWillBeNotifiedWhenTheFarmerUpdatesTheApplication: "Indique comentários ou instruções específicas na caixa de texto abaixo. Após o envio, o agricultor será notificado. Você será notificado quando o agricultor atualizar o pedido.",
            polygon: "Poligono",
            potassiumContent: "Teor de potassio",
            principalAndInterest: "Capital e juros",
            print: "Imprimir",
            projectedYieldComparisonByYear: "Comparacao de produtividade projetada por ano.",
            provinceState: "Provincia / Estado",
            question: "Questao",
            recordsPerPage: "Registos por pagina",
            regionDistrict: "Regiao / Distrito",
            reject: "Rejeitar",
            rejected: "Rejeitado",
            repaymentScheduleFromFarmerToBank: "Calendario de reembolso do agricultor para o banco.",
            requestAdditionalInformation: "Solicitar informacao adicional",
            restoreDefault: "Restaurar predefinicao",
            search: "Pesquisar",
            select: "Selecionar",
            selectFileToUploadTheContract: "Selecione o ficheiro para carregar o contrato",
            selectNoIfYouHaveAlreadySignedTheContractWithTheApplicantFarmerSelectYesIfYouWantTheApplicantFarmerToSignTheLoanContractOnHisDimitraMobileApp: "Selecione Nao se ja assinou o contrato com o requerente (agricultor). Selecione SIM se pretender que o requerente (agricultor) assine o contrato de credito na app movel Dimitra.",
            send: "Enviar",
            sendToBank: "Enviar ao banco",
            sentToBank: "Enviado ao banco",
            signedOffline: "Assinado offline",
            soilAnalysisReport: "Relatorio de analise de solo",
            someDisclaimerOrShortExplainerAboutFollowingReports: "Breve aviso ou explicacao sobre os relatorios seguintes.",
            srd: "SRD",
            startDate: "Data de inicio",
            status: "Estado",
            statusLegend: "Legenda de estados",
            submissionDate: "Data de submissao",
            success: "Sucesso",
            tapTheMapToExpandIt: "Toque no mapa para o expandir.",
            thisSectionShowsAdditionalInformationRequestsSentToTheFarmerAndTheirResponses: "Esta secao mostra os pedidos de informacao adicional enviados ao agricultor e as respetivas respostas.",
            thisSectionShowsAdditionalInformationRequestsSentToTheFarmerAndTheirResponsesYouWillBeNotifiedWhenTheFarmerUpdatesTheApplication: "Esta secao mostra os pedidos de informacao adicional enviados ao agricultor e as respetivas respostas. Sera notificado quando o agricultor atualizar o pedido.",
            totalInstallments: "Total de prestacoes",
            totalInterestApprox: "Juros totais (aprox.)",
            totalLoanAmount: "Montante total do credito",
            totalPayment: "Pagamento total",
            totalRepayment: "Reembolso total",
            transactionIdAndDate: "ID da transacao e data",
            typeYourLocationNameAddress: "Escreva o nome ou a morada da sua localizacao",
            upcoming: "Proximo",
            uploadTheUnsignedContractAfterYouAttachAndSaveItWillBeSentToTheFarmerToSignYouLlReceiveANotificationOnceItSSigned: "Carregue o contrato nao assinado. Apos anexar e guardar, sera enviado ao agricultor para assinatura. Recebera uma notificacao quando estiver assinado.",
            user: "Utilizador",
            userDetails: "Dados do utilizador",
            userRole: "Funcao do utilizador",
            validation: "Validacao",
            viewFullReport: "Ver relatorio completo",
            viewGeolocation: "Ver geolocalizacao",
            villageTownCity: "Aldeia / Cidade",
            waitingSignatures: "A aguardar assinaturas",
            warning: "Aviso",
            year2025: "2025",
            year2026: "2026",
            yesAttachTheContractAndWeLlSendItToTheFarmerToSignInTheApp: "Sim — anexe o contrato e envia-lo-emos ao agricultor para assinar na app",
            yieldPredictionReport: "Relatorio de previsao de produtividade",
            youMayUploadTheSignedContractForYourRecordsOrLeaveEmptyIfTheContractIsPrivateOrSignedOffline: "Pode carregar o contrato assinado para arquivo ou deixar em branco se for privado ou assinado offline.",
            yourRequestHasBeenSentTheFarmerWillBeNotified: "O seu pedido foi enviado. O agricultor sera notificado.",
            yieldForecastChartAria: "Grafico de previsao de produtividade",
            yearsAxisLabel: "Anos",
            soilAnalysisSectionTitle: "Analise de solo",
            soilMetricNitrogenN: "Azoto (N)",
            soilMetricPhosphorusP: "Fosforo (P2O5)",
            soilMetricPotassiumK: "Potassio (K2O)",
            soilAnalysisPlaceholderTitle: "O que isto significa (placeholder)",
            soilAnalysisPlaceholderBody: "Esta pagina mostra um resumo simplificado dos nutrientes do solo. Quando a fonte de dados do backend estiver integrada, esta secao podera ser expandida com graficos completos do perfil do solo e recomendacoes.",
            landSuitabilitySectionTitle: "Aptidao da terra",
            overallSuitabilityScoreLabel: "Pontuacao global de aptidao",
            suitabilityFactorsPlaceholder: "Fatores de aptidao (placeholder)",
            factorSoilQuality: "Qualidade do solo",
            factorClimateFit: "Adequacao climatica",
            factorWaterAvailability: "Disponibilidade de agua",
            factorRiskFactors: "Fatores de risco",
            landSuitabilityExpertFooter: "A IA pode errar; confirme com agronomos locais antes de decidir.",
        },
        banks: {
            title: 'Bancos',
            addNewBank: 'Adicionar novo banco',
            bankDetails: 'Detalhes do banco',
            bank: 'Banco',
            bankTitle: 'Titulo do banco',
            attachBankLogo: 'Anexar logotipo do banco',
            addImage: 'Adicionar imagem',
            contactDetails: 'Detalhes de contato',
            firstName: 'Nome',
            lastName: 'Sobrenome',
            email: 'E-mail',
            phone: 'Numero de telefone',
            enterHere: 'Digite aqui',
            apiIntegrationInfo: 'Informacoes de integracao da API',
            apiBaseUrl: 'URL base da API',
            clientId: 'ID do cliente / Chave publica',
            clientSecret: 'Segredo do cliente / Chave privada',
            accountAdminCredentials: 'Credenciais da conta/admin',
            adminUsername: 'Nome de usuario do administrador',
            password: 'Senha',
            require2FA: 'Exigir 2FA',
            enable: 'Ativar',
            copy: 'Copiar',
            regenerate: 'Regenerar',
            edit: 'Editar',
            back: 'Voltar',
            cancel: 'Cancelar',
            save: 'Salvar',
            firstNameInfo: 'Informacoes do nome',
            lastNameInfo: 'Informacoes do sobrenome',
            emailInfo: 'Informacoes do e-mail',
            phoneInfo: 'Informacoes do numero de telefone',
            apiBaseUrlInfo: 'Informacoes da URL base da API',
            clientIdInfo: 'Informacoes do ID do cliente',
            clientSecretInfo: 'Informacoes do segredo do cliente',
            adminUsernameInfo: 'Informacoes do nome de usuario do administrador',
            passwordInfo: 'Informacoes da senha',
            contactPerson: 'Pessoa de contato',
            management: 'Gestao financeira',
            editBank: 'Editar banco',
            changeImage: 'Alterar imagem',
            failedToLoadBankDetails: 'Falha ao carregar os detalhes do banco',
            bankUpdatedSuccessfully: 'Banco atualizado com sucesso',
            bankCreatedSuccessfully: 'Banco criado com sucesso',
            errorUpdatingBank: 'Erro ao atualizar banco',
            errorCreatingBank: 'Erro ao criar banco',
            bankLogo: 'Logotipo do banco',
            bankLogoPreview: 'Pre-visualizacao do logotipo do banco',
            notAvailable: 'N/D',
        },
        dashboard: {
            title: "Painel financeiro",
            avgLoanAmount: "Valor medio do emprestimo",
            vsLastMonth: "vs mes passado",
            totalApplications: "Total de solicitacoes",
            approvalRate: "Taxa de aprovacao",
            loanApplicationsChart: "Solicitacoes de emprestimo",
            applicationsByStatus: "Solicitacoes por status",
            applicationsByRegion: "Solicitacoes por regiao",
            regionBreakdown: "Distribuicao por regiao",
            averageLoanAmountTrend: "Tendencia do valor medio do emprestimo",
            loanAmountOverTime: "Valor do emprestimo ao longo do tempo",
            avgAmount: "Valor medio"
        },
        status: {
            approved: "Aprovado",
            pending: "Pendente",
            waiting: "Aguardando",
            rejected: "Rejeitado"
        },
        reports: {
            today: "Hoje",
            week: "Semana",
            month: "Mes",
            year: "Ano"
        },
    },
}
